import ContentItemContainer
  from '@components/Widgets/_contentItems/_contentItemContainer.vue'
import pxToEm from '@shared/components/mixins/shared/pxToEm'
import { position } from '@meta/widget/options'
import CloseButton
  from '@components/Widgets/_global/CloseButton/CloseButton.vue'
import ImageContentItem from '@components/Widgets/_contentItems/Image/Image.vue'

export default {
  name: 'ImageColumnStepPreview',
  mixins: [pxToEm],
  props: {
    widget: {
      required: true,
      type: Object,
    },
    targetStepIndex: {
      required: true,
      type: Number,
    },
  },
  components: {
    'content-item-container': ContentItemContainer,
    'close-button': CloseButton,
    'image-content-item': ImageContentItem,
  },
  data() {
    return {
      positionOptions: position,
    }
  },
  computed: {
    widgetSide() {
      const rightPositions = [
        this.positionOptions.TOP_RIGHT,
        this.positionOptions.CENTER_RIGHT,
        this.positionOptions.BOTTOM_RIGHT]
      return rightPositions.includes(this.widget.settings.position)
        ? 'right'
        : 'left'
    },
  },
}
